var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.466 0.181849L0.62475 6.70978C-0.0529703 7.01378 -0.282194 7.62256 0.460945 7.95295L4.78144 9.33308L15.2279 2.84361C15.7982 2.43621 16.3822 2.54485 15.8797 2.99301L6.90764 11.1586L6.62581 14.6142C6.88685 15.1478 7.36483 15.1503 7.66972 14.8851L10.152 12.5242L14.4032 15.7241C15.3906 16.3117 15.9279 15.9325 16.1403 14.8555L18.9288 1.58366C19.2183 0.258034 18.7246 -0.326051 17.466 0.181849Z",
    fill: "#4776E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.ed6ce9ec841fffb1e4cbad232e249c8c.svg";
export { ForwardRef as ReactComponent };